import { createContext } from "react";
import type { UnitTableOptions } from "@/types";
import { ButtonLayout, TableLayout, WidgetLayout, AppLocation } from "@/types/enums";

export const defaultDisplayOption: UnitTableOptions = {
    facilityIds: [0],
    tableLayout: TableLayout.ROW,
    buttonLayout: ButtonLayout.SEPARATE,
    widgetLayout: WidgetLayout.LAYOUT_1,
    disableRental: false,
    disableReservation: false,
    disableSoftReservation: true,
    allowedCategories: "",
    allowedFeatures: "",
    sort: "",
    featuredUnits: [],
    vacancyNotice: true,
    vacancyThreshold: 3,
    unavailableUnits: false,
    groupBy: "",
    rentalApp: {
        location: AppLocation.DIALOG,
    },
    reservationApp: {
        location: AppLocation.DIALOG,
    },
    softReservationApp: {
        location: AppLocation.DIALOG,
    },
    additionalUnitSourceInfo: "",
    showAppliedPromotionPrice: false,
    valueBasedPricingSettings: {
        tierA: {
            label: "Standard",
            description: "",
        },
        tierB: {
            label: "Best Value",
            description: "",
        },
        tierC: {
            label: "Deluxe",
            description: "",
        },
        tierOrder: ["tierA", "tierB", "tierC"],
    },
    language: {
        grid: {
            strikeThroughRate: "Starting at",
            webRate: "Web Rate",
            promoRate: "Promo Rate",
        },
        action: {
            reserveButton: "Reserve",
            rentButton: "Rent",
            selectButton: "Select",
            quoteButton: "Get a Quote",
        },
    },
    facilityMap: {},
};

export const DisplayOptionContext =
    createContext<UnitTableOptions>(defaultDisplayOption);
